import React from "react";
import SearchBar from "../components/SearchBar";
import SelectedFilters from "./SelectedFilters";
import EPDFilters from "./EPDFilters";
import SearchTable from "./SearchTable";
import { epdSearchStore } from "../EPDSearchStore";
import { useTranslation } from "react-i18next";
import useFeatureFlag from "hooks/useFeatureFlag";
import Button from "components/Button";
import { IconPlus } from "@tabler/icons-react";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router";
import { ROUTES_ENUM } from "routes/consts";
import { searchStore } from "features/ProductSearch/SearchStore";

const EPDSearchContent = (props: {
  open: boolean;
  close: () => void;
  datasetIndex?: number;
  rowIndex?: number;
  searchTerm?: string;
  generate?: boolean;
}) => {
  const { t } = useTranslation();
  const [term, setTerm] = React.useState<string>("");
  const onSearch = (value: string | number) => {
    setTerm(String(value));
    if (searchStore.openEPDSearch.state) {
      searchStore.setOpenEPDSearch({
        ...searchStore.openEPDSearch,
        term: String(value),
      });
    }
  };
  const [loading, setLoading] = React.useState(true);
  const { isFeatureVisible } = useFeatureFlag();
  const navigate = useNavigate();

  React.useEffect(() => {
    setTerm(props.searchTerm ?? "");
    setLoading(false);

    return () => epdSearchStore.reset();
  }, [props.open]);

  const redirectToCreateEPD = () => {
    navigate(`${ROUTES_ENUM.EPD_EDITOR}`);
  };

  const showCreateEPD =
    isFeatureVisible("epd_manager") &&
    epdSearchStore.isOrganisationalSearch &&
    !epdSearchStore.isExternalSearch;

  function externalLink() {
    return (
      <>
        {!epdSearchStore.isExternalSearch && (
          <div
            className="whitespace-nowrap text-indigo-700 hover:text-indigo-500 text-base font-medium lg:ml-5 cursor-pointer w-full"
            onClick={() => epdSearchStore.setIsExternalSearch(true)}
          >
            {t("productEditor.browseExternalDatabases")}
          </div>
        )}
        {epdSearchStore.isExternalSearch &&
          epdSearchStore.isOrganisationalSearch && (
            <div
              className="whitespace-nowrap text-indigo-700 hover:text-indigo-500 text-base font-medium lg:ml-5 cursor-pointer w-full"
              onClick={() => epdSearchStore.setIsExternalSearch(false)}
            >
              {t("productEditor.browseInternalDatabases")}
            </div>
          )}
      </>
    );
  }

  function createEPDButton() {
    return (
      <Button
        className="whitespace-nowrap lg:ml-2 min-w-auto lg:min-w-fit"
        type="primary"
        onClick={redirectToCreateEPD}
      >
        {t("mapping.createEPD")}
      </Button>
    );
  }

  if (loading) return null;
  return (
    <>
      <div className="flex w-full lg:items-center mb-2 flex-col lg:flex-row">
        <div className="flex items-center w-full mb-3 lg:mb-0">
          <SearchBar value={term} onChange={onSearch} open={props.open} />
          <EPDFilters />
        </div>
        {showCreateEPD ? createEPDButton() : externalLink()}
      </div>
      <SelectedFilters />
      <SearchTable
        term={term ?? props.searchTerm}
        datasetIndex={props.datasetIndex}
        rowIndex={props.rowIndex}
        close={() => props.close()}
        generate={props.generate}
        createEPDButton={createEPDButton}
      />
    </>
  );
};

export default observer(EPDSearchContent);
